// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1ZCNu","borderless":"style_borderless__1tCak","transparent":"style_transparent__HVI2Y","error":"style_error__3KGez"};